import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import ampmeLogo from '../../assets/images/ampme-logo.png'
import emptyCheck from '../../assets/icons/empty-check.svg'
import check from '../../assets/icons/check.svg'

import Image from '../shared/image'
import Link from '../shared/link'
import Minimizer from '../shared/minimizer'

import { device } from '../../lib/deviceSizes'
import states from '../../lib/states'

const Main = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;
  height: 100%;
  max-height: 400px;
  width: 100%;
  max-width: 600px;

  border: 1px solid #f1f1f1;
  background-color: #ffffff;

  @media ${device.xSmall} {
    height: 99%; /* when embedded in a iframe, we want 1 px to display the border */
    width: 99%; /* when embedded in a iframe, we want 1 px to display the border */
    margin: 0 auto;
  }
`

const Header = styled.div`
  height: 50%;
  padding-left: 20px;

  background-image: linear-gradient(224deg, #00fff2, #00b4fe);
`

const Logo = styled(Image).attrs({
  src: ampmeLogo
})`
  height : 30%;
  margin-top: 15px;
`

const HeaderTitle = styled.div`
  padding-left: 10px;

  font-size: 22px;
  @media ${device.xSmall} {
    font-size: 3.75vw;
  }
`

const HeaderSubTitle = styled.div`
  padding: 10px 20px 0 10px;

  font-size: 18px;
  @media ${device.xSmall} {
    font-size: 3vw;
  }
`

const Body = styled.div`
  height: 50%;
  padding: 15px 0 0 30px;
`

const BodyTitle = styled.div`
  margin-bottom: 15px;

  font-variant: small-caps;
  color: #9b9b9b;
`

const BodyElement = styled.div`
  display: flex;
  align-items: center;

  margin-top: 10px;

  font-size: 18px;
  @media ${device.xSmall} {
    font-size: 2.75vw;
  }
`

const EmptyCheckMark = styled(Image).attrs({
  src: emptyCheck
})`
  margin-right: 10px;
  width: 20px;
`

const CheckMark = styled(Image).attrs({
  src: check
})`
  margin-right: 10px;
  width: 20px;
`

const ExtensionLink = styled(Link).attrs({
  url: 'https://chrome.google.com/webstore/detail/ampme/ghakhdhfndeofamaiofohagbkbgpppja'
})`
  text-decoration: underline;
`

const AppLink = styled(Link).attrs({
  url: 'https://ampme.com/download'
})`
  text-decoration: underline;
`

class GetTheAppComponent extends Component {
  render() {
    return (
      <Main>
        <Minimizer />
        <Header>
          <Logo />
          <HeaderTitle>
            Hey welcome to Ampme!
          </HeaderTitle>
          <HeaderSubTitle>
            Are you ready to sync multiple devices and play millions of songs with your friends?
          </HeaderSubTitle>
        </Header>
        <Body>
          <BodyTitle>
          follow these steps to get started
          </BodyTitle>
          {((status) => {
            switch(status) {
            case states.MISSING:
              return (
                <BodyElement>
                  <EmptyCheckMark />
                  <ExtensionLink>
                    <div>
                      Download the web extension
                    </div>
                  </ExtensionLink>
                </BodyElement>
              )
            default:
              return (
                <BodyElement>
                  <CheckMark /> Download the web extension
                </BodyElement>
              )
            }
          })(this.props.status)}
          {((status) => {
            switch(status) {
            case states.DISCONNECTED:
              return (
                <BodyElement>
                  <EmptyCheckMark />
                  <AppLink>
                    <div>
                      Download the music server
                    </div>
                  </AppLink>
                </BodyElement>
              )
            default:
              return (
                <BodyElement>
                  <EmptyCheckMark /> Download the music server
                </BodyElement>
              )
            }
          })(this.props.status)}
          <BodyElement>
            <EmptyCheckMark />Download the mobile app
          </BodyElement>
        </Body>
      </Main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    status: state.status
  }
}

export const GetTheApp = connect(mapStateToProps, null)(GetTheAppComponent)



// WEBPACK FOOTER //
// ./src/components/getTheApp/getTheApp.js